import Currency from './currency';
import Customer from './customer';
import Stakeholder from './stakeholder';
import StakeholderType from './stakeholder-type';
import State from './state';
import Status from './status';
import Tag from './tag';
import Totals from './totals';

export function assertIsInstanceOfCurrency(value: unknown): asserts value is Currency {
	if (value instanceof Currency) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Currency`);
}
export function assertIsInstanceOfCustomer(value: unknown): asserts value is Customer {
	if (value instanceof Customer) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Customer`);
}
export function assertIsInstanceOfStakeholder(value: unknown): asserts value is Stakeholder {
	if (value instanceof Stakeholder) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Stakeholder`);
}
export function assertIsInstanceOfStakeholderType(value: unknown): asserts value is StakeholderType {
	if (value instanceof StakeholderType) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of StakeholderType`);
}
export function assertIsInstanceOfState(value: unknown): asserts value is State {
	if (value instanceof State) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of State`);
}
export function assertIsInstanceOfStatus(value: unknown): asserts value is Status {
	if (value instanceof Status) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Status`);
}
export function assertIsInstanceOfTag(value: unknown): asserts value is Tag {
	if (value instanceof Tag) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Tag`);
}
export function assertIsInstanceOfTotals(value: unknown): asserts value is Totals {
	if (value instanceof Totals) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Totals`);
}
